<obg-m-login-container
	*ngIf="!isLoginMfeEnable"
	test-id="login-container"
	data-test-id="login-container"
	[disallowLogin]="disallowLogin"
	showSgaLoginTitle
	showGenericLoginTitle
	stretchedTabs
	errorsInAlert
	(busy)=" handleLoading($event)"
>
</obg-m-login-container>

<ng-container *ngIf="isLoginMfeEnable && translations$ | async as translations">
	<account-login-fabric
		[translations]="translations"
		[error]="error"
		(rememberMeToggle)="rememberMeToggle($event.detail)"
		(registration)="routeLinks('registration')"
		(forgetPassword)="routeLinks('forgetPassword')"
		(loginValues)="loginValues($event.detail)"
	/>
</ng-container>
<obg-compact-footer [showJurisdictionLicenseLogo]="true"></obg-compact-footer>
